import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { downloadByZip } from "../../utils/downloadFile";
import "./index.less";

export const DownloadLogoFile = (props) => {
  const { isDownloadLogoFileShow, cancel, title, image } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <>
      {isDownloadLogoFileShow && (
        <div className="download-logo-file-show-container">
          <div className="cancel">
            <i
              onClick={() => cancel()}
              className="icon authing-icon authing-close-line"
            ></i>
          </div>
          <div className="content">
            <div className="title">{title}</div>
            <img src={image} className="image" alt="authing" />
            <div
              className="button"
              onClick={() => {
                downloadByZip(
                  [
                    {
                      downloadUrl:
                        "https://files.authing.co/authing-website/authing-logo/authing-logo-jpg.zip",
                      name: "authing-logo-jpg.zip" + Date.now(),
                    },
                    {
                      downloadUrl:
                        "https://files.authing.co/authing-website/authing-logo/authing-logo-png.zip",
                      name: "authing-logo-png.zip" + Date.now(),
                    },
                    {
                      downloadUrl:
                        "https://files.authing.co/authing-website/authing-logo/authing-logo-svg.zip",
                      name: "authing-logo-svg.zip" + Date.now(),
                    },
                    {
                      downloadUrl:
                        "https://files.authing.co/authing-website/authing-logo/authing-logo-ai.zip",
                      name: "authing-logo-ai.zip" + Date.now(),
                    },
                  ],
                  `logo-package${Date.now()}`
                );
              }}
            >
              {t("common.tool-package.toolTip.downMediaKit")}
            </div>
            <div
              className="lookPackage"
              onClick={() => navigate("/tool-package")}
            >
              {t("common.tool-package.toolTip.viewMediaKit")}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
